<template>
  <section class="section">
    <h1 class="title">
      <a @click="$router.go(-1)">
        <b-icon icon="arrow-left" />
      </a>
    </h1>
    <b-loading
      :is-full-page="true"
      :active.sync="isLoading"
      :can-cancel="false"
    ></b-loading>
    <user-form @formSubmit="callPostNewUser"> </user-form>
  </section>
</template>

<script>
import UserForm from '@/components/admin/users/UserForm'
import Fetcher from '@/mixins/fetcher.js'
import { mapActions } from 'vuex'

export default {
  mixins: [Fetcher],
  components: { UserForm },
  data() {
    return {}
  },
  methods: {
    ...mapActions('user', ['postPreCreatePartner']),
    callPostNewUser(newUserData) {
      let self = this
      self.request(() =>
        self.postPreCreatePartner(newUserData).then(function(response) {
          self.$toast.open({
            message: self.$t('Creado!'),
            type: 'success'
          })
          self.$router.push({
            name: 'admin.users.update',
            params: { id: response.PK }
          })
        })
      )
    }
  }
}
</script>

<style></style>
